import React, { useEffect, useContext, useState, useRef } from "react";
import './App.css';
import { Route, Routes, Link, useNavigate, useLocation } from 'react-router-dom';
import { Navbar, Nav, Row, Col, Dropdown, Form, Button, ToastContainer, Toast } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useCrackersCategories } from './hooks/useCrackersCategories';
import userProfile from './images/user_profile.png';
import logo from './images/logo.png';
import HomePage from './components/HomePage';
import Crackers from './components/Crackers';
import CrackersDetails from './components/CrackersDetails';
import { CrackersContext } from "./CrackersContext";
import ModalRoute from "./components/ModalRoute";

import { isSmScreen, isXSmScreen, queryString, isValidEmail, isValidMobileNumber, isValidPassword, numericInputOnly, isSmallTouchScreen } from './CrackersUtil';
import { userLogin, raiseGetRequest, raisePostRequest, getCarts, addBrowserCartItems } from './AxiosAPI';
import CartView from "./components/CartView";
import Support from "./components/Support";
import { LoadingBorder } from "./components/LoadingSpinner";
import CheckOut from "./components/CheckOut";
import Orders from "./components/Orders";
import OrderDetails from "./components/OrderDetails";
import AdminCrackersAdding from "./components/AdminCrackersAdding";
import AddingCrackersImage from "./components/AdminAddingCrackersImage";
import AccountsPage from "./components/AccountsPage";
import Faq from "./components/Faq";
import ylogo from "./images/youtube_logo.png"
import fblogo from "./images/facebook_logo.png"
import instlogo from "./images/insta_logo.png"
import xlogo from "./images/x_logo.png"
import whatsapp from "./images/whatsapp.gif"
import title from "./images/title_card.png"

// import bg from './images/bg.png';
import AdminCrackersProp from "./components/AdminCrackersProp";
import ForgotPassword from "./components/ForgotPassword";
import PasswordReset from "./components/PasswordReset";

function TopMenu({ userName, width, userWelcome, carts, userProfileOption, userProfileOptionOperation, setSelectedCart, getCartInfo, cartImageRef, getCurrentPath }) {
    const name = userName ? 'Hi, ' + userName : '';
    if (isXSmScreen(width) || isSmScreen(width)) {
        return (
            <div className="mp_mob_tm" style={{zIndex : "100"}}>
                <span style={userWelcome}>{name}</span>
                <div className="mob_tm_icons">
                    <BuildCartsDD carts={carts}
                        setSelectedCart={setSelectedCart}
                        getCartInfo={getCartInfo} 
                        cartImageRef={cartImageRef}
                        getCurrentPath={getCurrentPath}/>
                    <UserProfileOption userProfileOption={userProfileOption} userProfileOptionOperation={userProfileOptionOperation} />
                </div>
            </div>
        );
    } else {
        return (
            <>
                <Col md={3} style={userWelcome}>
                    <span style={userWelcome}>{name}</span>
                </Col>
                <Col md={7} className="d-flex justify-content-end" ></Col>
                <Col className='tm-icons' md={2}>
                    <BuildCartsDD carts={carts}
                        setSelectedCart={setSelectedCart}
                        getCartInfo={getCartInfo} 
                        cartImageRef={cartImageRef}
                        getCurrentPath={getCurrentPath}/>
                    <UserProfileOption userProfileOption={userProfileOption} userProfileOptionOperation={userProfileOptionOperation} />
                </Col>
            </>
        );
    }
}

function BuildCartsDD({ carts, setSelectedCart, getCartInfo, cartImageRef, getCurrentPath }) {

    const { setLandingPage, userInfo, browserCart, setActiveCart } = useContext(CrackersContext);

    const [choosenCart, setChoosenCart] = useState('');
    const navigate = useNavigate();
    useEffect(() => {
        if (carts && carts.length === 0) {
            setSelectedCart("Default");
            setActiveCart("Default");
            carts = ["Default"];
        }

        let cartNames = [];
        if (typeof carts === 'string' && carts.trim() !== '') {
            cartNames = carts.split(',');
        } else if (Array.isArray(carts)) {
            cartNames = carts;
        }

        const cartImageInit = async (cartName) => {
            const cartsData = await getCarts(userInfo, null, null, browserCart);
            if (cartsData && cartsData.length > 0) {
                // const cartList = cartsData.map((cart) => { return cart.name });
                const cartsInfo = {};
                for (let i = 0; i < cartsData.length; i++) {
                    cartsInfo[cartsData[i].name] = cartsData[i];
                }
                if (cartsInfo && cartsInfo[cartName] && cartImageRef.current) {
                    if (cartsInfo[cartName]['number_of_items'] > 0) {
                        cartImageRef.current.src = "/client/images/f_cart.png";
                    } else {
                        cartImageRef.current.src = "/client/images/cart.png";
                    }
                } 
                // else {
                //     cartImageRef.current.src = "/client/images/cart.png";
                // }
            }
        }

        
        if (cartNames.length > 0 && choosenCart === '') {
            let cartName = null;
            cartName = cartNames[0];
            setChoosenCart(cartName);
            setSelectedCart(cartName);
            setActiveCart(cartName);
            cartImageInit(cartName);
        }
    }, [carts, choosenCart, setSelectedCart]);

    function cartSwitch(eventKey, event) {
        var cartName = event.target.textContent;
        if(cartName === 'Why multi cart?' || cartName === 'Create new Cart') {
            return;
        }
        setChoosenCart(cartName);
        setSelectedCart(cartName);
        setActiveCart(cartName);
        cartImageSelector(cartName);
    }

    const cartNames = (typeof carts === 'string' && carts.trim() !== '') ? carts.split(',') : (Array.isArray(carts) ? carts : []);
    if (cartNames.length === 0) {
        return null;
    }

    function triggerAddCartRes() {
        setLandingPage(getCurrentPath());
        navigate("/web/addcart");
    }
    
    const createCartButton = (
        <Dropdown.Item as="button" onClick={triggerAddCartRes} disabled={!(carts && carts.length < 3)} key="cart-add-btn">
            Create new Cart
        </Dropdown.Item>
    )

    const cartFaqItems = (
        <Dropdown.Item as="a" href="/web/faq" target="_blank" rel="noopener noreferrer" key={'cart-faq'}>
            Why multi cart?
        </Dropdown.Item>
    )
    return (
        <>
            <a href="/web/cartview">
                <img className='icon-tm' src="/client/images/cart.png" alt="User Profile" ref={cartImageRef}/>
            </a>
            {
                <Dropdown onSelect={cartSwitch}>
                    <Dropdown.Toggle as="div" style={{ cursor: 'pointer', display: 'block', textAlign: 'center'}}>
                        <span>{choosenCart}</span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {cartNames.map((cart, index) => (
                            <Dropdown.Item key={index} eventKey={cart} active={cart === choosenCart}>{cart}</Dropdown.Item>
                        ))}

                        {
                            userInfo && userInfo.authenticated ? 
                            <>
                                <Dropdown.Divider/>
                                {createCartButton}
                                <Dropdown.Divider/>
                                {cartFaqItems}
                            </> : 
                            (null)
                        }
                    </Dropdown.Menu>
                </Dropdown>
            }
            
        </>
    );    

    function cartImageSelector(cartName) {
        var cartInfo = getCartInfo(cartName);
        if (cartInfo && cartInfo["number_of_items"] > 0) {
            cartImageRef.current.src = "/client/images/f_cart.png"; 
        } else {
            cartImageRef.current.src = "/client/images/cart.png";
        }
    }
}

function UserProfileOption({ userProfileOption, userProfileOptionOperation }) {
    return (
        <Dropdown className="cl_dd" onSelect={userProfileOptionOperation}>
            <Dropdown.Toggle as="div" style={{ cursor: 'pointer', display: 'block', textAlign: 'center' }}>
                <img className='icon-tm' src={userProfile} alt="User Profile" />
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {userProfileOption.map((option, index) => (
                    <Dropdown.Item key={index}>{option}</Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
}

function SignInPage({ landingPage, setUserInfo }) {
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const captionUserName = "Enter your Email ID to sign in";
    const captionPassword = "Enter your password";
    const [userNameCaption, setUserNameCaption] = useState(captionUserName);   
    const [passwordCaption, setPasswordCaption] = useState(captionPassword);
    const [userNameValidation, setUserNameValidation] = useState({});
    const [passwordValidation, setPasswordValidation] = useState({});
    const { setAgents, setShowErrorToastStatus, setToastBody, browserCart, setBrowserCart} = useContext(CrackersContext);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const unameRef = useRef(null);
    const passwordRef = useRef(null);
    const signinBtnRef = useRef(null);


    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const jsonObject = {};
        for (const [key, value] of params.entries()) {
            jsonObject[key] = value;
        }
        if (jsonObject["una"] && jsonObject["una"].trim() !== '') {
            setUserName(jsonObject["una"]);
            if(passwordRef) {
                passwordRef.current.focus();
            }
        } else {
            unameRef.current.focus();
        }

    }, []);

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            signinBtnRef.current.click();
        }
    };

    const validateEmail = () => {
        const errors = {};
        if (!userName) {
            errors.validation = false;
            errors.reason = "Email is required";
        } else if (!isValidEmail(userName)) {
            errors.validation = false;
            errors.reason = "Invalid Email";
        }
        if (Object.keys(errors).length > 0) {
            setUserNameValidation(errors);
            return false;
        } else {
            setUserNameValidation({ "validation": true});
            return true;
        }
    };

    const validateMobileNumber = () => {
        const errors = {};
        if (!userName) {
            errors.validation = false;
            errors.reason = "Mobile number is required";
        } else if (!isValidMobileNumber(userName)) {
            errors.validation = false;
            errors.reason = "Invalid Mobile Number";
        }
        if(Object.keys(errors).length > 0) {
            setUserNameValidation(errors);
            return false;
        } else {
            setUserNameValidation({"validation" : true});
            return true;
        }
    };

    const validateUserName = () => {
        return validateEmail();
    }

    const validatePassword = () => {
        const error = {};
        if (!password) {
            error.validation = false;
            error.reason = "Password is required";
            setPasswordValidation(error);
            return false;
        }
        const status = isValidPassword(password);
        if(status === 'success') {
            setPasswordValidation({"validation" : true});
            return true;
        } else {
            setPasswordValidation({"validation" : false, "reason" : status});
            return false;
        }
    }

    const login = async () => {
        validateUserName();
        validatePassword();
        const validation = userNameValidation.validation && validatePassword();
        if(validation) {
            const response = await userLogin(userName, password, setLoading);
            if (response.status === 'success') {
                setUserInfo(await raiseGetRequest(`/customer`, null, setShowErrorToastStatus, setToastBody));
                const agents = await raiseGetRequest(`/agents`, null, setShowErrorToastStatus, setToastBody);
                if(agents) {
                    setAgents(agents);
                }
                if(browserCart && browserCart !== '[]') {
                    await addBrowserCartItems(1000, browserCart, setBrowserCart);
                }
                if(landingPage === "/web/signup" || landingPage === "/web/signin") {
                    navigate("/");
                } else {
                    navigate(landingPage);
                }
                
                window.location.reload();
            } else {
                const errors = {};
                switch (response.message) {
                    case "invalid mobile number":
                        setUserNameValidation({"reason" : 'Couldn’t find your Account.', "validation" : false});
                        break;
                    case "Bad credentials":
                        setPasswordValidation({"reason" : 'Wrong password. Try again or click Forgot password to reset it.', "validation" : false});
                        break;
                    default:
                        setPasswordValidation({"reason" : response.message, "validation" : false});
                }
            } 
        } else {
            return null;
        }
    }
    
    const userNameOnFocus = () => {
        setUserNameCaption("Email ID");
    }

    const userNameOnBlur = async() => {
        if(!userName || userName.trim() === '') {
            setUserNameCaption(captionUserName);
            return;
        }
        const userNameValStatus = validateUserName();
        if(userNameValStatus) {
            const staus = await raisePostRequest(`/customer/user-name-check`, {"user_name" : userName}, null, setShowErrorToastStatus, setToastBody);
            if(!staus.user_exist) {
                setUserNameValidation({"reason" : "This account is not registered with us. If you don't have an account, kindly sign up with us.", "validation" : false});
            }
        }
    }

    const passwordOnFocus = async() => {
        setPasswordCaption("Password");
    }

    const passwordOnBlur = async() => {
        if(!password || password.trim() === '') {
            setPasswordCaption(captionPassword);
            return;
        }
        validatePassword();
    }

    const signInImage = {
                            height : isSmallTouchScreen(window.innerWidth) ? "100%" : "100%", 
                            width : isSmallTouchScreen(window.innerWidth) ? "90%" : "90%", 
                            paddingTop : "20px",
                            marginLeft : "5%"
                        };

    return (
        <Row className="align-items-center">
            <Col lg={7} className="d-flex justify-content-center">
                <div>
                    <img style={signInImage} src={title}/>
                </div>
            </Col>
            <Col lg={5} className="d-flex justify-content-center">
                <div className="login_body" onKeyDown={handleKeyDown}>
                    <Form>

                        <Form.Group className="login_body_ip form-floating">
                            <Form.Control
                                type="text"
                                value={userName}
                                onFocus={userNameOnFocus}
                                onChange={(e) => setUserName(e.target.value)}
                                onBlur={userNameOnBlur}
                                placeholder=""
                                className={`form-control ${userNameValidation.reason ? 'is-invalid' : ''}`}
                                ref={unameRef}
                                tabIndex={1}
                            />
                            <Form.Label>{userNameCaption}</Form.Label>
                            <Form.Control.Feedback type="invalid">
                                {userNameValidation.reason}
                            </Form.Control.Feedback>
                            <Form.Text className="text-muted">
                                We'll never share your Email with anyone else.
                            </Form.Text>
                        </Form.Group>

                        {/* <Form.Group className="login_body_ip form-floating">
                            <Form.Control
                                type="text"
                                value={userName}
                                onFocus={userNameOnFocus}
                                onKeyDown={(e) => numericInputOnly(e)}
                                onChange={(e) => setUserName(e.target.value)}
                                onBlur={userNameOnBlur}
                                placeholder={userNameCaption}
                                className={`form-control ${userNameValidation.reason ? 'is-invalid' : ''}`}
                            />
                            <Form.Label>{userNameCaption}</Form.Label>
                            <Form.Control.Feedback type="invalid">
                                {userNameValidation.reason}
                            </Form.Control.Feedback>
                            <Form.Text className="text-muted">
                                We'll never share your mobile phone number with anyone else.
                            </Form.Text>
                        </Form.Group> */}
                        <Form.Group className="login_body_ip form-floating">
                            <Form.Control
                                type="password"
                                value={password}
                                onFocus={passwordOnFocus}
                                onChange={(e) => setPassword(e.target.value)}
                                onBlur={passwordOnBlur}
                                placeholder="Enter text"
                                className={`form-control ${passwordValidation.reason ? 'is-invalid' : ''}`}
                                ref={passwordRef}
                                tabIndex={2}
                            />
                            <Form.Label>{passwordCaption}</Form.Label>
                            <Form.Control.Feedback type="invalid">
                                {passwordValidation.reason}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <div className="login_body_ctrl">
                            <div className="login_body_ctrl_item">
                                <Button className="signin_btn" style={{width : '100px', height : '60px'}} ref={signinBtnRef} variant="primary" onClick={login} disabled={loading} tabIndex={3}>
                                    {!loading && "Sign In"}
                                    {loading && <LoadingBorder />}
                                </Button>
                            </div>
                            <div className="login_body_ctrl_item">
                                <a href="/web/forget/password">Forgot your password?</a>
                            </div>
                            <div className="login_body_ctrl_item">
                                <span tabIndex={4}>
                                    Don't have an account? <a href="/web/signup">Register here</a>
                                </span>
                            </div>
                        </div>
                    </Form>
                </div>
            </Col>
        </Row>
        
    );
}

function SignUpPage() {
    const { setShowErrorToastStatus, setToastBody } = useContext(CrackersContext);
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [cpassword, setCpassword] = useState("");
    const [nameValidation, setNameValidation] = useState({});
    const [mobileValidation, setMobileValidation] = useState({});
    const [emailValidation, setEmailValidation] = useState({});
    const [passwordValidation, setPasswordValidation] = useState({});
    const [cpasswordValidation, setCpasswordValidation] = useState({});
    const captionName = "Enter your name", captionMobNum = "Enter your 10 digit mobile phone number", 
            captionEmail = "Enter your Email", captionPwd = "Enter your password", captionCPwd = "Gives once again same Password";
    const [nameCaption, setNameCaption] = useState(captionName);
    const [mobNumCaption, setMobNumCaption] = useState(captionMobNum);
    const [emailCaption, setEmailCaption] = useState(captionEmail);
    const [passwordCaption, setPasswordCaption] = useState(captionPwd);
    const [cPasswordCaption, setCPasswordCaption] = useState(captionCPwd);

    const nameRef = useRef(null);
    const signupBtnRef = useRef(null);

    const navigate = useNavigate();

    const validateName = () => {
        const errors = {};
        if(!name) {
            errors.validation = false;
            errors.reason = "Name is required";
        }
        if(Object.keys(errors).length > 0) {
            setNameValidation(errors);
        } else {
            setNameValidation({"validation" : true});
        }
    }

    const validateMobileNumber = () => {
        const errors = {};
        if (!mobileNumber) {
            errors.validation = false;
            errors.reason = "Mobile number is required";
        } else if (!isValidMobileNumber(mobileNumber)) {
            errors.validation = false;
            errors.reason = "Invalid Mobile Number";
        }
        if(Object.keys(errors).length > 0) {
            setMobileValidation(errors);
            return false;
        } else {
            setMobileValidation({"validation" : true});
            return true;
        }
    }

    const validateEmail = () => {
        const errors = {};
        if (!email) {
            errors.validation = false;
            errors.reason = "Email is required";
        } else if (!isValidEmail(email)) {
            errors.validation = false;
            errors.reason = "Invalid Email";
        }
        if (Object.keys(errors).length > 0) {
            setEmailValidation(errors);
            return false;
        } else {
            setEmailValidation({ "validation": true});
            return true;
        }
    };

    const validatePassword = () => {
        const errors = {};
        if (!password) {
            errors.validation = false;
            errors.reason = "Password is required";
            setPasswordValidation(errors);
            return false;
        }

        const status = isValidPassword(password);
        if(status === 'success') {
            setPasswordValidation({"validation" : true});
            return true;
        } else {
            setPasswordValidation({"validation" : false, "reason" : status});
            return false;
        }
    }

    const validateCPassword = () => {
        const errors = {};
        if (!cpassword) {
            errors.validation = false;
            errors.reason = "Please confirm password again";
            setCpasswordValidation(errors);
            return false;
        } else if (password !== cpassword) {
            errors.validation = false;
            errors.reason = "Password and confirm password are mismatched";
            setCpasswordValidation(errors);
            return false;
        } else {
            errors.validation = true;
            setCpasswordValidation(errors);
            return true;
        }
    }

    const clear = () => {
        setName('');
        setMobileNumber('');
        setEmail('');
        setPassword('');
        setCpassword('');
        setNameValidation({});
        setMobileValidation({});
        setEmailValidation({});
        setPasswordValidation({});
        setCpasswordValidation({});
    }

    const triggerSignup = async () => {
        validateName();
        validateMobileNumber();
        validateEmail();
        validatePassword();
        validateCPassword();
        const validation = nameValidation.validation && mobileValidation.validation && emailValidation.validation && passwordValidation.validation && cpasswordValidation.validation;
        if (validation) {
            var data = {
                "user_name" : name,
                "phone_number" : mobileNumber,
                "email_id" : email,
                "password" : password
            }
            var response = await raisePostRequest(`/customer/signup`, data, setLoading, setShowErrorToastStatus, setToastBody);
            if (response.status && response.status === 'success') {
                navigate(`/web/signin?una=${email}`);
            } else {
                const errorCode = response.error_code;
                switch(errorCode) {
                    case "40010": 
                        setEmailValidation({"reason" : "The email ID is already registered with us. Kindly log in to your account.", "validation" : false});
                    break;
                    case "40011":
                        setMobileValidation({"reason" : "This mobile phone number is already associated with another email ID.", "validation" : false});
                }
            }
            console.log(response);
        }
    }

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            signupBtnRef.current.click();
        }
    };

    useEffect(() => {
        if(nameRef) {
            nameRef.current.focus();
        }
    }, [])

    const nameIpOnFocus = () => {
        setNameCaption("Name");
    }

    const nameIpOnBlur = () => {
        if(!name || name.trim() === '') {
            setNameCaption(captionName);
        }
        validateName();
    }

    const mobNumOnFocus = () => {
        setMobNumCaption("Mobile Number");
    }

    const mobNumOnBlur = async () => {
        if(!mobileNumber || mobileNumber.trim() === '') {
            setMobNumCaption(captionMobNum);
        }
        const mobValStatus = validateMobileNumber();
        if(mobValStatus) {
            const status = await raisePostRequest(`/customer/ph-no-check`, {"ph_no" : mobileNumber}, null, setShowErrorToastStatus, setToastBody);
            if(status.phone_exist) {
                setMobileValidation({"validation" : false, "reason" : "This mobile phone number is already associated with another email ID."});
            }
        }
    }

    const emailIpOnFocus = () => {
        setEmailCaption("Email");
    }

    const emailIdOnBlur = async () => {
        if(!email || email.trim() === '') {
            setEmailCaption(captionEmail);
            // return;
        }
        const emailValStatus = validateEmail();
        if(emailValStatus) {
            const status = await raisePostRequest(`/customer/email-id-check`, {"email_id" : email}, null, setShowErrorToastStatus, setToastBody);
            if(status.email_exist) {
                setEmailValidation({"validation" : false, "reason" : "The email ID is already registered with us. Kindly log in to your account."});
            }
        }
    }

    const passwordIPOnFoucs = () => {
        setPasswordCaption("Password");
    }

    const passwordIPOnBlur = () => {
        if(!password || password.trim() === '') {
            setPasswordCaption(captionPwd);
        }
        validatePassword();
    }

    const cPasswordIPOnFoucs = () => {
        setCPasswordCaption("Confirm Password");
    }

    const cPasswordIPOnBlur = () => {
        if(!cpassword || cpassword.trim() === '') {
            setCPasswordCaption(captionCPwd);
        }
        validateCPassword();
    }

    return(
        <Row>
            <Col md={7} className="d-flex justify-content-center">
                <div>
                    <img style={{height : "550px", width : "978px", paddingTop : "20px"}} src={title}/>
                </div>
            </Col>
            <Col md={1}></Col>
            <Col md={4}>
                <div className="login_body" onKeyDown={handleKeyDown}>
                    <Form>
                    <Form.Group className="login_body_ip form-floating">
                            <Form.Control
                                ref={nameRef}
                                type="text"
                                value={name}
                                onFocus={nameIpOnFocus}
                                onChange={(e) => setName(e.target.value)}
                                onBlur={nameIpOnBlur}
                                placeholder={nameCaption}
                                className={`form-control ${nameValidation.reason ? 'is-invalid' : ''}`}
                                tabIndex={1}
                            />
                            <Form.Label>{nameCaption}</Form.Label>
                            <Form.Control.Feedback type="invalid">
                                {nameValidation.reason}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="login_body_ip form-floating">
                            <Form.Control
                                type="text"
                                value={mobileNumber}
                                onFocus={mobNumOnFocus}
                                onKeyDown={(e) => numericInputOnly(e)}
                                onChange={(e) => setMobileNumber(e.target.value)}
                                onBlur={mobNumOnBlur}
                                placeholder=""
                                className={`form-control ${mobileValidation.reason ? 'is-invalid' : ''}`}
                                tabIndex={2}
                            />
                            <Form.Label>{mobNumCaption}</Form.Label>
                            <Form.Control.Feedback type="invalid">
                                {mobileValidation.reason}
                            </Form.Control.Feedback>
                            <Form.Text className="text-muted">
                                We'll never share your mobile phone number with anyone else.
                            </Form.Text>
                        </Form.Group>

                        <Form.Group className="login_body_ip form-floating">
                            <Form.Control
                                type="text"
                                value={email}
                                onFocus={emailIpOnFocus}
                                onChange={(e) => setEmail(e.target.value)}
                                onBlur={emailIdOnBlur}
                                placeholder=""
                                className={`form-control ${emailValidation.reason ? 'is-invalid' : ''}`}
                                tabIndex={3}
                            />
                            <Form.Label>{emailCaption}</Form.Label>
                            <Form.Control.Feedback type="invalid">
                                {emailValidation.reason}
                            </Form.Control.Feedback>
                            <Form.Text className="text-muted">
                                We'll never share your Email with anyone else.
                            </Form.Text>
                        </Form.Group>
                        
                        <Form.Group className="login_body_ip form-floating">
                            <Form.Control
                                type="password"
                                value={password}
                                onFocus={passwordIPOnFoucs}
                                onChange={(e) => setPassword(e.target.value)}
                                onBlur={passwordIPOnBlur}
                                placeholder=""
                                className={`form-control ${passwordValidation.reason ? 'is-invalid' : ''}`}
                                tabIndex={4}
                            />
                            <Form.Label>{passwordCaption}</Form.Label>
                            <Form.Control.Feedback type="invalid">
                                {passwordValidation.reason}
                            </Form.Control.Feedback>
                            <Form.Text className="text-muted">
                                Password must be 8–16 characters and can include A–Z, a–z, 0–9, and ! @ # $ % ^ & * _ + - = ?
                            </Form.Text>
                        </Form.Group>

                        <Form.Group className="login_body_ip form-floating">
                            <Form.Control
                                type="password"
                                value={cpassword}
                                onFocus={cPasswordIPOnFoucs}
                                onChange={(e) => setCpassword(e.target.value)}
                                onBlur={cPasswordIPOnBlur}
                                placeholder=""
                                className={`form-control ${cpasswordValidation.reason ? 'is-invalid' : ''}`}
                                tabIndex={5}
                            />
                            <Form.Label>{cPasswordCaption}</Form.Label>
                            <Form.Control.Feedback type="invalid">
                                {cpasswordValidation.reason}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <div className="login_body_ctrl">
                            <div className="signup_body_ctrl_item">
                                <Button variant="light" onClick={clear} tabIndex={7}>
                                    Clear
                                </Button>
                                <Button style={{ width: "90px", height: "40px", marginLeft : "10%", marginRight : "10%"}} variant="primary" onClick={triggerSignup} disabled={loading} tabIndex={6} ref={signupBtnRef}>
                                    {!loading && "Register"}
                                    {loading && <LoadingBorder />}
                                </Button>
                            </div>
                            <div className="login_body_ctrl_item">
                                <span>
                                    Do you have an account? <a href="/web/signin">Sign in here</a>
                                </span>
                            </div>
                        </div>
                    </Form>
                </div>
            </Col>
        </Row>
    );
}

function AddCart() {
    const [cartName, setCartName] = useState("");
    const [cartNameValidation, setCartNameValidation] = useState({"validation" : true});
    const [loading, setLoading] = useState(false);

    const { landingPage, setShowErrorToastStatus, setToastBody } = useContext(CrackersContext);

    const cartEleRef = useRef(null);
    const ctCreBtnRef = useRef(null);

    const navigate = useNavigate();


    useEffect(() => {
        if(cartEleRef) {
            cartEleRef.current.focus();
        }
    }, []);

    function validation() {
        const error = {};
        if(cartName.trim() === '') {
            error.validation = false;
            error.reason = 'Cart Name should not be empty';
        }

        if(Object.keys(error).length > 0) {
            setCartNameValidation(error);
        } else {
            setCartNameValidation({"validation" : true});
        }
    }

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            ctCreBtnRef.current.click();
        }
    }

    const addCartToServer = async () => {
        var data = {
            "cart_name" : cartName,
        }
        const response = await raisePostRequest(`/carts`, data, setLoading, setShowErrorToastStatus, setToastBody);
        if(response.status && response.status === 'failure') {
            console.log(response);
        } else {
            navigate(landingPage);
            window.location.reload();
        }
        
    }

    return(
        <div className="login_body" onKeyDown={handleKeyDown}>
            <Form>
                <Form.Group controlId="cart_name" className="login_body_ip">
                    <Form.Label>Cart Name</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter the Cart Name"
                        value={cartName}
                        onChange={(e) => setCartName(e.target.value)}
                        ref={cartEleRef}
                        isInvalid={!cartNameValidation.validation}
                        onBlur={validation}
                        tabIndex={1} />
                    <Form.Control.Feedback type="invalid">
                        {cartNameValidation.reason}
                    </Form.Control.Feedback>
                </Form.Group>
                <div className="login_body_ctrl">
                    <div className="login_body_ctrl_item">
                        <Button className="ctcre_btn" ref={ctCreBtnRef} variant="primary" tabIndex={2} onClick={addCartToServer} disabled={loading}>
                            {!loading && "Add Cart"}
                            {loading && <LoadingBorder />}
                        </Button>
                    </div>
                </div>
            </Form>
        </div>
    );
}

function MainContent() {
    const navigate = useNavigate(); // Use the hook here
    const { category, loading, error } = useCrackersCategories();
    const { serviceCommonData, setServiceCommonData,
        agents, setAgents, 
        crackersData, setCrackersData,
        agentCode, setAgentCode,
        crackersFilter, setCrackersFilter,
        crackersCategory, setCrackersCategory,
        userInfo, setUserInfo,
        landingPage, setLandingPage,
        cartsInfo, setCartsInfo,
        carts, setCarts,
        showErrorToastStatus, setShowErrorToastStatus,
        toastBody, setToastBody, browserCart, isZeroCasePage } = useContext(CrackersContext);
    const [userName, setUserName] = useState(null);
    const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });
    const [userProfileOption, setUserProfileOption] = useState(["Sign In", "Sign Up"]);
    const [selectedCart, setSelectedCart] = useState(null);
    const location = useLocation();
    const mobileNumberRef = useRef(null);
    const cartImageRef = useRef(null);
    const [expanded, setExpanded] = useState(false);

    const handleMenuItemClick = (e) => {
        setExpanded(false);
        if(e.target.text === 'All Crackers') {
            navigate(`/web/crackers?filter=All&agent_id=${serviceCommonData["default_agent_id"]}`);
            window.location.reload();
        }
    };

    const userWelcome = {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        paddingLeft: (isSmScreen(windowSize.width) || isXSmScreen(windowSize.width)) ? "5%" : "2%",
        fontWeight: "bold"
    };

    useEffect(() => {

        document.title = "CrackleCart";

        const fetchAgents = async () => {
            const agents = await raiseGetRequest(`/agents`, null, setShowErrorToastStatus, setToastBody);
            if(agents) {
                setAgents(agents);
            }
        };
        
        const fetchServiceCommonData = async () => {
            const serviceCommonData = await raiseGetRequest(`/customer/common-data`, null, null, null);
            if(serviceCommonData && Object.keys(serviceCommonData).length > 0) {
                setServiceCommonData(serviceCommonData);
            } else {
                setServiceCommonData(JSON.parse("{}"));
            }
        }

        const fetchAuthStatus = async () => {
            try {
                const customerInfo = await raiseGetRequest(`/customer`, null, setShowErrorToastStatus, setToastBody);
                if (customerInfo && customerInfo.authenticated === true) {
                    setUserInfo(customerInfo);
                } else {
                    setUserInfo(null);
                    setSelectedCart("Default");
                    cleanUpLocalStorage();
                }
                updateCustomerInfo(customerInfo);
            } catch (error) {
                console.error('Error fetching customers:', error);
            }
        };

        fetchServiceCommonData();
        fetchAuthStatus();
        fetchAgents();
        

        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };

        if (mobileNumberRef.current) {
            mobileNumberRef.current.focus(); // Set focus on the mobile number input element when the component mounts
        }

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [setUserInfo, setWindowSize, mobileNumberRef]);

    const userProfileOptionOperation = async (eventKey, event) => {
        const option = event.target.textContent.toLowerCase();

        switch (option) {
            case "sign in":
                setLandingPage(getCurrentPath());
                navigate(serviceCommonData["link_signin"] ? serviceCommonData["link_signin"] : '/web/signin');
            break;
            case "account setting":
                navigate('/web/accounts');
            break;
            case "sign out":
                try {
                    var logoutResponse = await raiseGetRequest(`/logout`, null, setShowErrorToastStatus, setToastBody);
                    if (logoutResponse.status === 'success') {
                        cleanUpLocalStorage();
                        
                        navigate(logoutResponse.redirection_url || '/'); // Use the navigate function here
                        window.location.reload();
                    } else {
                    }
                } catch (error) {
                    console.error("Error during logout:", error);
                }
            break;
            case "sign up":
                setLandingPage(getCurrentPath());
                navigate(serviceCommonData["link_signup"] ? serviceCommonData["link_signup"] : '/web/signup');
            break;
            default:
            break;
        }
    };

    function getCurrentPath() {
        const queryParams = queryString(new URLSearchParams(location.search));
        if (queryParams && queryParams.trim() !== '') {
            return location.pathname + "?" + queryParams;
        } else {
            return location.pathname;
        }
    }

    const updateCustomerInfo = async (userInfo) => {
        const cartsData = await getCarts(userInfo, null, null, browserCart);
        if (cartsData && cartsData.length > 0) {
            const cartList = cartsData.map((cart) => { return cart.name });
            setCarts(cartList);

            const cartsInfo = {};
            for (let i = 0; i < cartsData.length; i++) {
                let cartInfo = {};
                cartsInfo[cartsData[i].name] = cartsData[i];
            }
            setCartsInfo(cartsInfo);
        }
        if(userInfo && userInfo.authenticated) {
            setUserName(userInfo.username);
            setUserProfileOption(["Account Setting", "Sign Out"]);
        } else {
            setUserProfileOption(["Sign In", "Sign Up"]);
        }
    }

    const getCartInfo = (cartName) => {
        if (cartsInfo) {
            return cartsInfo[cartName];
        } else {
            return null;
        }
    }

    const toggleErrorToast = () => {
        setShowErrorToastStatus(false)
        setToastBody({"toastType" : "light", "toastTitle" : "", "toastMessage" : "" });
    };

    return (
        
        <div>
            <div style={{width : '100%', position:'sticky', top : '0px', zIndex : "1001", background : "white"}}> 
            {/* <div> */}
                <Row>
                    <TopMenu
                        userName={userName}
                        width={windowSize.width}
                        userWelcome={userWelcome}
                        carts={carts}
                        userProfileOption={userProfileOption}
                        userProfileOptionOperation={userProfileOptionOperation}
                        setSelectedCart={setSelectedCart}
                        getCartInfo={getCartInfo}
                        cartImageRef={cartImageRef}
                        getCurrentPath={getCurrentPath}
                    />
                </Row>
                <Navbar expanded={expanded} expand="md" className="bg-body-tertiary menu-nav-bar" data-bs-theme="dark">
                    <Navbar.Brand as={Link} to="/web" onClick={(e) => {handleMenuItemClick(e)}}>
                    <img src={logo} alt="Logo" style={{height : "35px", marginLeft : "20px"}} />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" 
                        onClick={() => setExpanded(expanded ? false : "expanded")}
                    />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto nav-bar-item">
                            <Nav.Link onClick={handleMenuItemClick}>All Crackers</Nav.Link>
                            <Nav.Link as={Link} to="/web/cartview" onClick={handleMenuItemClick}>View Cart</Nav.Link>
                            {
                                userInfo && userInfo.authenticated ? 
                                        (
                                            <Nav.Link as={Link} to="/web/orders" onClick={handleMenuItemClick}>Orders</Nav.Link>
                                        ) : 
                                        (null)
                            }
                            <Nav.Link as={Link} to="/web/faq" onClick={handleMenuItemClick}>FAQ</Nav.Link>
                            <Nav.Link as={Link} to="/web/support" onClick={handleMenuItemClick}>Support</Nav.Link>
                            {
                                userInfo && userInfo.isAdmin ? 
                                (
                                    <>
                                        <Nav.Link as={Link} to="/web/vnradmin/add-crackers" onClick={handleMenuItemClick}>Add Crackers</Nav.Link>
                                        <Nav.Link as={Link} to="/web/vnradmin/crackers-prop" onClick={handleMenuItemClick}>Crackers Prop</Nav.Link>
                                    </>
                                ) : 
                                (null)
                            }
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </div>
            
            {/* <div style={{position:'relative', top: '3%', left: '0px'}}> */}
            <div>
                <Routes>
                    <Route path="/" element={<HomePage/>} />
                    <Route path="/web" element={<HomePage/>} />
                    <Route path="/web/signin" element={<SignInPage
                                                landingPage={landingPage}
                                                setUserInfo={setUserInfo}
                                                mobileNumberRef={{ mobileNumberRef }}/>}/>
                    <Route
                        path="/web/signup" element={<SignUpPage
                                    landingPage={landingPage}
                                    setUserInfo={setUserInfo}
                                    mobileNumberRef={{mobileNumberRef}}/>}/>
                    
                    <Route path="/web/forget/password" element={<ForgotPassword/>}/>

                    <Route path="/web/reset/password" element={<PasswordReset/>}/>
                    {/* <Route
                        path="/web/signin"
                        element={
                            <ModalRoute path="/web/signin" title={"Sign In to Our Service"} getBackPage={"/web"}>
                                <SignInPage
                                    landingPage={landingPage}
                                    setUserInfo={setUserInfo}
                                    mobileNumberRef={{ mobileNumberRef }} />
                            </ModalRoute>

                        }
                    /> */}
                    {/* <Route
                        path="/web/signup"
                        element={
                            <ModalRoute path="/web/signup" title={"Registration to Our Service"}>
                                <SignUpPage
                                    landingPage={landingPage}
                                    setUserInfo={setUserInfo}
                                    mobileNumberRef={{ mobileNumberRef }} />
                            </ModalRoute>

                        }
                    /> */}
                    <Route
                        path="/web/addcart"
                        element={
                            <ModalRoute path="/web/addcart" title={"Create a new Cart"}>
                                <AddCart/>
                            </ModalRoute>

                        }
                    />
                    <Route path="/web/crackers" element={<Crackers selectedCart={selectedCart}
                        cartImageRef={cartImageRef} />} />
                    <Route path="/web/crackers/:crackerId" element={<CrackersDetails/>} />
                    <Route path="/web/cartview" element={<CartView/>}/>
                    <Route path="/web/orders" element={<Orders/>}/>
                    <Route path="/web/orders/:orderId" element={<OrderDetails/>}/>
                    <Route path="/web/support" element={<Support/>} />
                    <Route path="/web/checkout" element={<CheckOut/>} />
                    <Route path="/web/faq" element={<Faq/>} />
                    <Route path="/web/vnradmin/add-crackers" element={<AdminCrackersAdding/>} />
                    <Route path="/web/vnradmin/crackers-prop" element={<AdminCrackersProp/>}/>
                    <Route path="/web/vnradmin/add-crackers-images" element={<AddingCrackersImage/>} />
                    <Route path="/web/accounts" element={<AccountsPage/>} />
                </Routes>
            </div>

            <ToastContainer position="top-center" className="p-3">
                <Toast show={showErrorToastStatus} onClose={toggleErrorToast} bg={toastBody["toastType"]} delay={5000} autohide={true}>
                    <Toast.Header>
                        <strong className="me-auto">{toastBody.toastTitle}</strong>
                    </Toast.Header>
                    <Toast.Body>{toastBody.toastMessage}</Toast.Body>
                </Toast>
            </ToastContainer>

            <div style={{backgroundColor : "skyblue", marginTop : "3%", padding : "2%" }} hidden={isZeroCasePage}>
                <Row>
                    <Col md={1}></Col>
                    <Col md={4}>
                        <div style={{textAlign : "justify"}}>
                            <h3 style={{color : "#FF5C00"}}><img src={logo} alt="Logo" style={{height : "35px", marginRight : "-18px"}} />rackleCart</h3>
                            <span style={{fontSize : "20px", color: "#000000"}}>We make it easy for you to purchase firecrackers at wholesale or retail prices. We never compromise on quality, ensuring a vibrant bloom to your festivities.</span>
                        </div>
                    </Col>
                    <Col md={1}></Col>
                    <Col md={6}>
                        <div style={{textAlign : "justify"}}>
                            <h1 style={{color: "#000000"}}>Delivery Procedure</h1>
                            <span style={{fontSize : "20px", color: "#000000"}}>We ship your order through a parcel service that operates in your area or the nearest location. Once your shipment is dispatched, you will need to pick it up from the designated parcel service vendor after making the payment for transportation. <a href="/web/faq">FAQ</a></span>
                        </div>        
                    </Col>
                </Row>
                <div style={{marginTop : "1%"}}>
                    {/* <Row>
                        <Col sm={12} className="d-flex justify-content-center">
                            <p>Follow Us</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12} className="d-flex justify-content-center">
                            <a href="https://www.youtube.com/@CrackleCart" target="_blank"><img src={ylogo} style={{height : "30px", width : "30px", margin : "8px"}}/></a>
                            <a href="https://www.facebook.com/people/Crackle-Cart/61579770170723/" target="_blank"><img src={fblogo} style={{height : "30px", width : "30px", margin : "8px"}}/></a>
                            <a href="https://www.instagram.com/crackle.cart28/" target="_blank"><img src={instlogo} style={{height : "30px", width : "30px", margin : "8px"}}/></a>
                            <a href="https://facebook.com" target="_blank"><img src={xlogo} style={{height : "30px", width : "30px", margin : "8px"}}/></a>
                        </Col>
                    </Row> */}
                    <Row>
                        <Col sm={12} className="d-flex justify-content-center">
                            <p>Contact Us</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12} className="d-flex justify-content-center">
                            📧<strong><a href="mailto:support@cracklecart.com" target="_blank"> support@cracklecart.com</a></strong><br></br>
                        </Col>
                        <Col sm={12} className="d-flex justify-content-center">
                            <img style={{width : "15px", height : "15px"}} src={whatsapp}></img><strong><a href="https://wa.me/919043012805" target="_blank"> +91 90430 12805</a></strong><br></br>
                        </Col>
                    </Row>
                </div>
            </div>
            
        </div>
    );

    function cleanUpLocalStorage() {
        setUserName(null);
        setCarts([]);
        setUserProfileOption(["Sign In", "Sign Up"]);
        setSelectedCart(null);
    
        setServiceCommonData(JSON.parse("{}"));
        setAgents([]);
        setCrackersData(null);
        // setAgentCode(null);
        setCrackersFilter([]);
        setCrackersCategory([]);
        setUserInfo(null);
        setLandingPage("/");
        setCartsInfo({});
        setCarts([]);
        setShowErrorToastStatus(false);
        setToastBody({"toastType" : "light", "toastTitle" : "", "toastMessage" : "" });
    }
}

export default MainContent;
